<template>
  <div class="col-md-12" v-if="data && data.count && data.count > 10">
    <div
      class="btn-toolbar justify-content-center"
      role="toolbar"
      aria-label="Toolbar with button groups"
    >
      <div class="btn-group mr-2" role="group" aria-label="First group">
        <button
          type="button"
          class="btn btn-success"
          @click="onClickFirstPage"
          :disabled="isInFirstPage"
        >
          &lt;&lt;
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="onClickPreviousPage"
          :disabled="isInFirstPage"
        >
          &lt;
        </button>
        <button
          type="button"
          class="btn btn-success"
          v-for="page in pages"
          :key="page.name"
          :disabled="page.isDisabled"
          :class="{ active: isPageActive(page.name) }"
          @click="onClickPage(page.name)"
        >
          {{ page.name }}
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="onClickNextPage"
          :disabled="isInLastPage"
        >
          &gt;
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="onClickLastPage"
          :disabled="isInLastPage"
          v-if="tipo != 'MINI'"
        >
          &gt;&gt;
        </button>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    data: {
      count: {
        type: Number,
        required: false,
        default: 3,
      },
    },
    currentPage: {
      type: Number,
      required: true,
    },
    tipo: {
      type: String,
      required: false,
      default: "COMPLETO",
    },
  },
  computed: {
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
    totalPages() {
      return Math.ceil(this.data.count / 10);
    },
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1;
      }
      if (this.totalPages <= this.maxVisibleButtons) {
        return 1;
      }
      // When on the last page
      if (this.currentPage === this.totalPages) {
        return this.totalPages + 1 - this.maxVisibleButtons;
      }
      // When in between
      return this.currentPage - 1;
    },
    maxVisibleButtons() {
      let number = 5;
      if (this.tipo == "MINI") {
        number = 3;
      }
      return number;
    },
    pages() {
      const range = [];
      for (
        let i = this.startPage;
        i <=
        Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        i += 1
      ) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage,
        });
      }

      return range;
    },
  },
  methods: {
    isPageActive(page) {
      return this.currentPage === page;
    },
    onClickFirstPage() {
      this.$emit("pagechanged", 1);
    },
    onClickPreviousPage() {
      this.$emit("pagechanged", this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit("pagechanged", page);
    },
    onClickNextPage() {
      this.$emit("pagechanged", this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit("pagechanged", this.totalPages);
    },
  },
};
</script>

<style scoped>
.col-md-12 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
@media (max-width: 575.98px) {
  .btn-group {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
  }
  .btn-group .btn {
    padding: 0.3rem 0.6rem !important;
    font-size: 0.8rem !important;
    margin: 2px !important;
    border-radius: 4px !important;
    flex: 0 0 auto !important;
  }
}
</style>
